import { Flex, Button } from "antd";
import { IconHelp } from "@tabler/icons-react";
import { Notification, ProfileButton } from "../../components/header";
import {TrialUpdate} from "../../components/header";
import { IconButton } from "../../components/common/index";
import { GlobalContext } from "../../lib/context";
import styles from "./styles.module.css";
import React, { useState, useEffect, useContext } from 'react';
const imageBaseURL = `${process.env.REACT_APP_IMAGE_URL || ""}`;
const getFileNameFromPath = (imagePath: string) => {
  return imagePath ? imagePath.split('/').pop() || "" : "";
};



const Header = () => {
  const { profile } = useContext(GlobalContext);
  const [logo, setLogo] = useState(null);
  const path = `${process.env.REACT_APP_BASE_URL || ""}`;
  const image_path = path + "/images/header_logo.jpg";
  useEffect(() => {
    // Retrieve the image from localStorage
    const storedLogo = profile.company_logo;
    const UpdatedLogo = localStorage.getItem('company_logo') || '';
    if (UpdatedLogo) {
      setLogo(UpdatedLogo);  // Set the image source to the base64 string
    }else {
      setLogo(storedLogo);  // Set the image source to the base64 string
    }
  }, []);

  return (
    <header className={styles.header}>
      <div className="d-flex justify-between items-center h-15 container">
    {/* <header className={styles.header}>
      <Flex align="center" justify="space-between"> */}
        {logo ? (
          <a
            href={`${process.env.REACT_APP_BASE_URL || ""}/dashboard`}
            className={styles.logo}
          >
            <img src={imageBaseURL + getFileNameFromPath(logo)} alt="COEXSYS"  className={styles.companyLogo} />
          </a>

        ) : (
          <a
            href={`${process.env.REACT_APP_BASE_URL || ""}/`}
            className={styles.logo}
          >
               <img src={image_path} alt="COEXSYS" style={{height:"40px"}} />
          </a>
        )}
        <Button
          type="primary"
          size="small"
          href={`${process.env.REACT_APP_PSA_URL || ""}/`}
          // href="https://ylot.com/psa"
        >
          Dashboard
        </Button>
        <TrialUpdate/>


        <Flex align="center" gap={4}>
          <Button
            type="link"
            href={`${process.env.REACT_APP_BASE_URL || ""}/dashboard`}
          >
            Admin Workbench
          </Button>

          {/* <Notification /> */}

          <IconButton>
            <IconHelp color="#666" size={18} />
          </IconButton>

          <ProfileButton />
        </Flex>
      </div>
    </header>
  );
};

export default Header;

